 
import { initComponent } from './core/init-component.js'

initComponent('.js-ff-footer', section => {
  const gorgiasButton = section.querySelector('.js-gorgias-open')  

  const initGorgiasChatPromise = window.GorgiasChat
    ? window.GorgiasChat.init()
    : new Promise(function (resolve) {
        window.addEventListener('gorgias-widget-loaded', function () {
          resolve()
        })
      })
  
  initGorgiasChatPromise.then(() => {        
    gorgiasButton &&
      gorgiasButton.addEventListener('click', function () {
        const gorgiasWidget = document.querySelector('#gorgias-chat-container #chat-button')
        if (GorgiasChat.isOpen()) {
          GorgiasChat.close()
          gorgiasWidget.style.display = 'none'          
        } else {
          GorgiasChat.open()
          gorgiasWidget.style.display = 'block'          
        }
      })
  })  

  return {
    unload() {}
  }
})
  
